import { EventName, createComponent } from '@lit/react';
import { BlocksBreadcrumbs } from 'blocks-nextjs/blocks-web-components/components/breadcrumbs/breadcrumbs';
import { BlocksBreadcrumbChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';

export const CatBreadcrumbs = createComponent({
  react: React,
  tagName: 'cat-breadcrumbs',
  elementClass: BlocksBreadcrumbs,
  events: {
    onBlBreadcrumbChange: 'bl-breadcrumb-change' as EventName<BlocksBreadcrumbChangeEvent>
  }
});
